/* Steps accordion */
function toggleStep(header){
  var step=header.closest('.step');
  var isOpen=step.classList.contains('open');
  document.querySelectorAll('.step').forEach(s=>s.classList.remove('open'));
  if(!isOpen){
    step.classList.add('open');
    var stepNum=header.dataset.step||'1';
    document.querySelectorAll('[id^="step-img-"]').forEach(function(img){
      img.style.opacity='0';
    });
    var target=document.getElementById('step-img-'+stepNum);
    if(target) target.style.opacity='1';
    else { var first=document.getElementById('step-img-1'); if(first) first.style.opacity='1'; }
  }
}

/* FAQ accordion */
function toggleFaqKp(q){
  var item=q.closest('.faq-item-kp');
  item.classList.toggle('open');
}

/* Approche reveal */
function toggleApproche(btn){
  var mores=btn.parentElement.querySelectorAll('.approche-more');
  var isOpen=btn.classList.contains('open');
  mores.forEach(function(el){el.style.display=isOpen?'none':'block';});
  btn.classList.toggle('open',!isOpen);
  btn.innerHTML=isOpen?'Voir plus <i class="ti ti-chevron-down"></i>':'Voir moins <i class="ti ti-chevron-up"></i>';
}

/* Anchor nav active */
const sections=['approche','comment','offres','temoignages','faq-kp'];
const anavLinks=document.querySelectorAll('.anav a');
const onScroll=()=>{
  let cur='';
  sections.forEach(id=>{
    const el=document.getElementById(id);
    if(el&&el.getBoundingClientRect().top<120) cur=id;
  });
  anavLinks.forEach(a=>{
    a.classList.toggle('on', a.getAttribute('href')==='#'+cur);
  });
};
addEventListener('scroll',onScroll,{passive:true});

/* Smooth scroll */
document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
  const t=document.querySelector(a.getAttribute('href'));
  if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
}));
